import { convertRoleOptionsToOptions, convertStateOptionsToOptions } from 'src/utils';
import { createReducer } from 'typesafe-actions';
import { getLevelsAsync, getRolesAsync, getTradesAsync } from './actions';
import { Option, RoleOption } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

const INITIAL_STATUS = [
  {
    label: 'Inactive',
    value: 'inactive',
  },
  {
    label: 'Active',
    value: 'active',
  },
];

export type IContentState = Readonly<{
  trades: Array<{ label: string; value: number }>;
  levels: Array<{ label: string; value: number }>;
  roles: Array<{ label: string; value: number }>;
  status: Array<{ label: string; value: string }>;
}>;

const initialState: IContentState = {
  trades: [],
  levels: [],
  roles: [],
  status: INITIAL_STATUS,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- employeesAsync ------------- */
  .handleAction(getRolesAsync.success, (state, action) => ({
    ...state,
    roles: convertRoleOptionsToOptions(action.payload.data as RoleOption[]),
    error: null,
  }))
  .handleAction(getRolesAsync.failure, (state, action) => ({
    ...state,
    error: action.payload,
  }))

  /* ------------- employeesOptionAsync ------------- */
  .handleAction(getTradesAsync.success, (state, action) => ({
    ...state,
    trades: convertStateOptionsToOptions(action.payload.data as Option[]),
    error: null,
  }))
  .handleAction(getTradesAsync.failure, (state, action) => ({
    ...state,
    error: action.payload,
  }))
  /* ------------- employeesUpdateAsync ------------- */
  .handleAction(getLevelsAsync.success, (state, action) => ({
    ...state,
    levels: convertStateOptionsToOptions(action.payload.data as Option[]),
    error: null,
  }))
  .handleAction(getLevelsAsync.failure, (state, action) => ({
    ...state,
    error: action.payload,
  }));
